/* mm-card-swipe.js v1.2 (2026-10-05; v1.2 adds a gentle reveal on the home page: blocks below the first screen rise 12 px and fade in once as they scroll into view, never when the visitor has turned motion off, cards waiting in a swipe row show with their row, see the end of the file; v1.1 v1.1 adds: expanding photo panels return to their opening panel when the mouse leaves, see the end of the file): every product card on every page (home, collections, search, "you may also like").
   Laptop: the theme's hover already fades to the second photo (the PDP's model photo).
   Phones (< 750 px): the product photo and the model photo sit side by side; swipe to see it on the model, two small dots show where you are.
   Same behavior as the collection grid (sections/mm-collection-filters.liquid builds the same .mm-swipe, so both can run together). */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function build(m) {
    var a = m.querySelector(':scope > img.media--first');
    var b = m.querySelector(':scope > img.media--second');
    if (!a || !b || m.querySelector('.mm-swipe')) return;
    var w = document.createElement('div');
    w.className = 'mm-swipe';
    m.insertBefore(w, a);
    w.appendChild(a); w.appendChild(b);
    var d = document.createElement('span');
    d.className = 'mm-dots'; d.setAttribute('aria-hidden', 'true'); d.setAttribute('data-i', '0');
    d.innerHTML = '<i></i><i></i>';
    m.appendChild(d);
    w.addEventListener('scroll', function () { d.setAttribute('data-i', String(Math.round(w.scrollLeft / Math.max(1, w.clientWidth)))); }, { passive: true });
    w.addEventListener('click', function () {
      var card = m.closest('.card-wrapper, .card, li');
      var l = card && card.querySelector('.card__title a, a.full-unstyled-link, a[href*="/products/"]');
      if (l) window.location.href = l.href;
    });
    var c = m.closest('.card-wrapper'); if (c) c.classList.add('mm-has2');
  }
  function unbuild(m) {
    var sw = m.querySelector(':scope > .mm-swipe'); if (!sw) return;
    while (sw.firstChild) m.insertBefore(sw.firstChild, sw);
    sw.remove();
    var dd = m.querySelector(':scope > .mm-dots'); if (dd) dd.remove();
    var c = m.closest('.card-wrapper'); if (c) c.classList.remove('mm-has2');
  }
  function run() {
    document.querySelectorAll('.card--product .card__inner .media').forEach(function (m) { mq.matches ? build(m) : unbuild(m); });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(run, 120); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  if (mq.addEventListener) mq.addEventListener('change', run);
  new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', soon);
})();

/* Expanding photo panels (theme section gallery-with-text, e.g. home Shop by Category): the theme opens the panel you hover
   and leaves it open. When the mouse leaves the band, go back to the panel(s) set open in the theme editor
   (Mangalsutras on the home page), so the biggest photo is always the category you chose to lead with. */
(function () {
  function init() {
    document.querySelectorAll('.gallery-with-text__wrapper').forEach(function (w) {
      if (w.dataset.mmReset) return;
      w.dataset.mmReset = '1';
      var cards = Array.prototype.slice.call(w.querySelectorAll('.gallery-with-text__card'));
      var open = cards.filter(function (c) { return c.classList.contains('active'); });
      if (!open.length || open.length === cards.length) return;
      w.addEventListener('mouseleave', function () {
        cards.forEach(function (c) {
          var on = open.indexOf(c) > -1;
          c.classList.toggle('active', on);
          var l = c.querySelector('.link--overlay'); if (l) l.classList.toggle('active', on);
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* v1.2 Home reveal (Shreya 10-05). Only blocks that start below the first screen are hidden, so nothing flashes on load.
   Classes are removed after the fade so theme hover effects keep working. Off in the theme editor and with reduced motion. */
(function () {
  if (!document.body || !document.body.classList.contains('template-index')) return;
  if (window.Shopify && Shopify.designMode) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = [
    '.products-grid-section__top', '.card-wrapper', '.gallery-with-text__card',
    '.mmcol__nav', '.mmcol__photo',
    '.mmfn__photo', '.mmfn__text',
    '.mmcu__photo', '.mmcu__body',
    '.mmts__head', '.mmts__card',
    '.mmex__photo', '.mmex__card', '.mmex__item',
    '.mm-standard .mm-below__eyebrow', '.mm-standard .mm-below__h', '.mm-standard__card'
  ].join(',');
  function run() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var vh = window.innerHeight;
    var els = Array.prototype.slice.call(main.querySelectorAll(SEL)).filter(function (el) {
      if (el.closest('.shopify-section') === main.querySelector('.shopify-section')) return false;
      if (el.parentElement && el.parentElement.closest('.mm-rv-i')) return false;
      return el.getBoundingClientRect().top > vh;
    });
    if (!els.length) return;
    document.documentElement.classList.add('mm-rv');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        /* reveal this block plus any in the same band that are level with it, so cards waiting off to the side in a swipe row show too */
        var sec = e.target.closest('.shopify-section') || main;
        var limit = window.innerHeight;
        Array.prototype.forEach.call(sec.querySelectorAll('.mm-rv-i:not(.is-v)'), function (el) {
          if (el !== e.target && el.getBoundingClientRect().top > limit) return;
          io.unobserve(el);
          el.classList.add('is-v');
          setTimeout(function () { el.classList.remove('mm-rv-i', 'is-v'); el.style.removeProperty('--mm-rv-d'); }, 1400);
        });
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach(function (el) {
      var sibs = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(SEL); }) : [el];
      var i = Math.max(0, sibs.indexOf(el));
      el.style.setProperty('--mm-rv-d', Math.min(i, 4) * 80 + 'ms');
      el.classList.add('mm-rv-i');
      io.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
